export default "__VITE_ASSET__cd6a72bd__"